import { useQuery } from "@tanstack/react-query";
import {
  type MyInvitationsResult,
  getInvitations,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const MY_INVITATIONS_QUERY_KEY = "MY_INVITATIONS";

export const myInvitationsKeys = {
  all: [MY_INVITATIONS_QUERY_KEY],
};

/**
 * Lists pending role invitations targeting the current Identity. Items returned with
 * `isAcceptable: false` and `blockedReason: "KycRequired"` are gated by FullMoone — show the row
 * but disable the Accept button, link to Customer KYC upgrade.
 */
export const useGetMyInvitationsQuery = (enabled = true) =>
  useQuery<MyInvitationsResult>({
    queryKey: myInvitationsKeys.all,
    queryFn: processResponseWithApiProblemDetails(() => getInvitations()),
    enabled,
  });
